import React, { useState } from 'react';
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import { TfiCup } from "react-icons/tfi";

const cards = [
  {
    title: 'Winner – CSR in Real Estate Category',
    subtitle: 'Golden Peacock Award 2022',
  },
  {
    title: 'Winner – Environmental & Social Initiatives – Infrastructure & Real Estate',
    subtitle: 'KPMG ESG Conclave and Awards 2023',
  },

  {
    title: 'RD – Global Asian Brand of the Year',
    subtitle: '19th Asian Business & Social Forum 2022–2023',
  },
  {
    title: 'India’s Top Builder – Gold Award',
    subtitle: '16th Construction World Architect & Builder Awards 2021',
  },
  {
    title: 'Excellence in Green Building Initiatives',
    subtitle: 'IGBC Green Champion Awards 2023',
  },
  {
    title: 'Most Trusted Real Estate Brand – South India',
    subtitle: 'Times Business Awards 2022',
  },
  {
    title: 'Innovation in Smart Living',
    subtitle: 'Smart Cities India Expo 2024',
  },
];

const Recognized = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCards = 4;

  const handlePrev = () => {
    setStartIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setStartIndex((prev) => Math.min(prev + 1, cards.length - visibleCards));
  };

  return (
    <div className='bg-[#fdfbf0] py-8 px-4 max-w-screen-2xl mx-auto'>
      {/* Title Section */}
      <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-4 text-center">
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-800 whitespace-nowrap">
          RECOGNIZED BY THE BEST
        </h1>
        <div className="w-40 sm:w-72 h-0.5 bg-gray-300"></div>
      </div>


      {/* Description */}
      <h1 className='text-gray-700 text-lg sm:text-2xl text-center font-sans mb-10'>
        “RDS has received over 400 awards and <br className="hidden sm:block" />
        recognitions in the recent years.”
      </h1>

      {/* Slider Section */}
      <div className='flex items-center justify-center space-x-2 sm:space-x-4'>
        {/* Prev Arrow */}
        <button
          onClick={handlePrev}
          className='p-2 rounded-full border-2 border-gray-500 border-dashed hidden sm:flex'
        >
          <FaArrowLeftLong size={24} className='text-gray-500' />
          
        </button>

        {/* Card Container */}
        <div className='flex overflow-x-auto sm:overflow-hidden space-x-4 sm:space-x-6 scrollbar-hide'>
          {(window.innerWidth < 640 ? cards : cards.slice(startIndex, startIndex + visibleCards)).map((card, idx) => (
            <div
              key={idx}
              className='md:min-w-[240px]  min-w-[140px] sm:w-72 h-72 bg-white shadow-md mb-6 p-4 rounded-tr-3xl rounded-tl-3xl rounded-bl-3xl flex flex-col justify-between flex-shrink-0'
            >
              <div className='text-yellow-500 text-4xl'><TfiCup /></div>
              <div className='text-lg font-semibold text-gray-800'>{card.title}</div>
              
              <div className='text-sm text-gray-500'>{card.subtitle}</div>
            </div>
          ))}
        </div>

        {/* Next Arrow */}
        <button
          onClick={handleNext}
          className='p-2 rounded-full border-2 border-gray-500 border-dashed hidden sm:flex'
        >
          <FaArrowRightLong size={24} className='text-gray-500' />
        </button>

        {/* <div></div> */}
      </div>
    </div>
  );
};

export default Recognized;
